import React from 'react';
import { formatAmount } from '../../datasets/utils/formatters';

interface FeeStructureTableProps {
  title: string;
  merchantFees: {
    fixedFee: number;
    percentageFee: number;
    maxCap: number;
  };
  bankFees: {
    fixedFee: number;
    percentageFee: number;
    maxCap: number;
  };
}

export function FeeStructureTable({ title, merchantFees, bankFees }: FeeStructureTableProps) {
  const MarginCell = ({ value, suffix = '' }: { value: number; suffix?: string }) => (
    <span className={`text-[13px] font-medium ${value >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
      {value >= 0 ? '+' : ''}{suffix ? `${value.toFixed(3)}${suffix}` : formatAmount(value)}
    </span>
  );

  return (
    <div className="card">
      <div className="px-5 py-3 border-b border-slate-100">
        <h3 className="section-title">{title}</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="px-5 py-3 text-left text-[12px] font-medium text-slate-400 uppercase tracking-wider">Fee Type</th>
              <th className="px-5 py-3 text-left text-[12px] font-medium text-slate-400 uppercase tracking-wider">Merchant</th>
              <th className="px-5 py-3 text-left text-[12px] font-medium text-slate-400 uppercase tracking-wider">Bank</th>
              <th className="px-5 py-3 text-left text-[12px] font-medium text-slate-400 uppercase tracking-wider">Margin</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            <tr>
              <td className="px-5 py-3 text-[13px] font-medium text-slate-900">Fixed Fee</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{formatAmount(merchantFees.fixedFee)}</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{formatAmount(bankFees.fixedFee)}</td>
              <td className="px-5 py-3"><MarginCell value={merchantFees.fixedFee - bankFees.fixedFee} /></td>
            </tr>
            <tr>
              <td className="px-5 py-3 text-[13px] font-medium text-slate-900">Percentage Fee</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{merchantFees.percentageFee}%</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{bankFees.percentageFee}%</td>
              <td className="px-5 py-3"><MarginCell value={merchantFees.percentageFee - bankFees.percentageFee} suffix="%" /></td>
            </tr>
            <tr>
              <td className="px-5 py-3 text-[13px] font-medium text-slate-900">Max Cap</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{formatAmount(merchantFees.maxCap)}</td>
              <td className="px-5 py-3 text-[13px] text-slate-600">{formatAmount(bankFees.maxCap)}</td>
              <td className="px-5 py-3"><MarginCell value={merchantFees.maxCap - bankFees.maxCap} /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
